/******************************************************
 *                  Open-iti export
 ********************************************************/

"use strict";

angular.module("exploitation")

	.controller("OpenExportsCtrlDetails", [
		"$scope", "Utils", "$uibModal", "OpenExportsService", "exportData", "actionReport", "okinaJobData", "$controller", "$interval", "CONSTANTS",
		function ($scope, Utils, $uibModal, OpenExportsService, exportData, actionReport, okinaJobData, $controller, $interval, CONSTANTS) {

		$controller("OpenExportsCtrlParent", {$scope: $scope});

		$scope.data = {
			exportData: exportData.data,
			actionReport: actionReport.data.action_report,
			detailMode: true,
			okinaJobStatus: okinaJobData.data,
			display : {}
		};

		if($scope.data.actionReport.objects !== undefined){
			$scope.data.actionReport.objects.forEach(function(zeObject) {
				$scope.data.actionReport.objects[zeObject.type.toLowerCase()] = zeObject.stats[zeObject.type.toLowerCase()];
			});
		}
		var jobStatusCheckerFunction;

		// On monitore pour rafraichir la page
		if ($scope.data.exportData.status === "STARTED") {
			jobStatusCheckerFunction = $interval(function () {
				OpenExportsService.getExport($scope.data.exportData.referential, $scope.data.exportData.id).then((response) => {
					const jobData = response.data;
					$scope.data.exportData = jobData;

					// JOB Terminé => on stoppe la fonction périodique
					if (jobData.status === "TERMINATED") {
						stopCheckerFunction();

						// On démarre ensuite un nouveau monitoring pour vérifier la complétion des actions Okina à la suite de l'export IEV.
						OpenExportsService.okinaJobStatusChecker($scope.data.exportData.referential, jobData.id);

						$scope.data.okinaJobStatus = "IN_PROGRESS";

					}

					// JOB toujours en cours => on récupère le rapport d'action pour MAJ de la progression
					else {
						OpenExportsService.getActionReport($scope.data.exportData.referential, $scope.data.exportData.id).then((response) => {
							$scope.data.actionReport = response.data;
							$scope.data.globalValue = $scope.data.actionReport.progression.current_step;
							$scope.data.globalMaxValue = $scope.data.actionReport.progression.steps_count;
							$scope.data.subtaskValue = $scope.data.actionReport.progression.steps[$scope.data.actionReport.progression.current_step - 1].realized;
							$scope.data.subtaskMaxValue = $scope.data.actionReport.progression.steps[$scope.data.actionReport.progression.current_step - 1].total;
						});
					}
				});
			}, 6000);
		}

		if ($scope.data.okinaJobStatus !== "TERMINATED") {
			OpenExportsService.okinaJobStatusChecker($scope.data.exportData.referential, $scope.data.exportData.id);
		}


		$scope.$on(CONSTANTS.EVENT_EXPORT_COMPLETE, function () {
			$scope.data.okinaJobStatus = "TERMINATED";
			displayDetailsExport();
			/* OpenExportsService.getValidationReport($scope.data.exportData.referential, $scope.data.exportData.id)
                .then(function(data) {
                    $scope.data.validationReport = data.validation_report;
                })
           */
		});


		/**
         * Stopper la fonction périodique de vérification de statut du job.
         */
		function stopCheckerFunction() {
			if (angular.isDefined(jobStatusCheckerFunction)) {
				$interval.cancel(jobStatusCheckerFunction);
				jobStatusCheckerFunction = undefined;
			}
		}


		/**
         * Pour être sur que la fonction est détruite lorsqu'on change de page.
         */
		$scope.$on("$destroy", function () {
			stopCheckerFunction();
		});

		/**
		 * Récupération des détails des exports et affichage
		 */
		function displayDetailsExport(){

			// On vérifier que l'exportation est terminée avant d'aller chercher les infos sur les éléments exportés
			if($scope.data.okinaJobStatus === "TERMINATED"){

				if ($scope.data.actionReport.collections[0] == null || $scope.data.actionReport.collections[0] === undefined) {
					OpenExportsService
						.getActionReport($scope.data.exportData.referential, $scope.data.exportData.id)
						.then((response) => {
							$scope.data.actionReport = response.data;
							displayDetailsExport();
						});
				} else {
					// Donnée Company
					if ($scope.data.actionReport.collections[0].stats.COMPANY === undefined) {
						$scope.data.display.company = getStatForType("COMPANY");
					}
					else {
						$scope.data.display.company = "--";
					}

					// Donnée Réseau
					if ($scope.data.actionReport.collections[0].stats.NETWORK === undefined) {
						$scope.data.display.network = getStatForType("NETWORK");
					}
					else {
						$scope.data.display.network = "--";
					}

					// Donnée Correspondance
					if ($scope.data.actionReport.collections[0].stats.CONNECTION_LINK === undefined) {
						$scope.data.display.connectionLink = getStatForType("CONNECTION_LINK");
					}
					else {
						$scope.data.display.connectionLink = $scope.data.actionReport.collections[0].stats.CONNECTION_LINK;
					}

					// Donnée Calendrier
					if ($scope.data.actionReport.collections[0].stats.TIMETABLE === undefined) {
						$scope.data.display.timetable = getStatForType("TIMETABLE");
					}
					else {
						$scope.data.display.timetable = $scope.data.actionReport.collections[0].stats.TIMETABLE;
					}

					// Donnée Arrêt
					if ($scope.data.actionReport.collections[0].stats.STOP_AREA === undefined) {
						$scope.data.display.stopArea = getStatForType("STOP_AREA");
					}
					else {
						$scope.data.display.stopArea = $scope.data.actionReport.collections[0].stats.STOP_AREA;
					}
				}
			}
		}

		displayDetailsExport();


	      function getStatForType(type) {
			  let statObjectList;
			  if($scope.data.actionReport.objects !== undefined) {
				  statObjectList = $scope.data.actionReport.objects.filter(function (obj) {
					  return obj.type === type;
				  });
			  }

			if (statObjectList && statObjectList.length > 0) {
				return statObjectList[0].stats[type];
			} else {
				return 0;
			}
		}

	}]);
